import React, { useEffect } from 'react';
const PIXEL_ID = '1322788416056310';
/**
 * Inicializa el Meta Pixel (Facebook Pixel) y dispara el evento PageView.
 * Inyecta el snippet oficial de fbevents.js. No renderiza nada visible.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    let noscript: HTMLElement | null = null;
    const loadPixel = () => {
      const w = window as any;
      // Se carga luego del contenido principal para preservar la respuesta en 4G.
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
      noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    };
    // Se ejecuta casi de inmediato pero cediendo el hilo principal para no bloquear el renderizado inicial
    const timer = window.setTimeout(loadPixel, 100);
    return () => {
      window.clearTimeout(timer);
      noscript?.remove();
    };
  }, []);
  return null;
}